import React from "react";
import { ListItemButton, ListItemText, Collapse, List, Link as MuiLink } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Category } from "../../../../types/Category";
import { interceptLeftClick } from "@ecommerce/shared-utils";
import { STYLES } from "../../../ShoppingCart/ShoppingCartStyles";

interface CategoryItemProps {
    category: Category;
    subcategories: Category[];
    isExpanded: boolean;
    level: number;
    onToggle: (categoryId: number) => void;
    onCategoryClick: (category: Category) => void;
    onViewAllClick: (category: Category) => void;
    renderCategory: (category: Category, level: number) => React.ReactNode;
}

export const CategoryItem: React.FC<CategoryItemProps> = ({
    category,
    subcategories,
    isExpanded,
    level,
    onToggle,
    onCategoryClick,
    onViewAllClick,
    renderCategory,
}) => {
    const hasSubcategories = subcategories.length > 0;

    const href = `/categoria/${category.sku}`;

    return (
        <>
            <MuiLink
                href={href}
                underline="none"
                color="inherit"
                onClick={interceptLeftClick(() => {
                    if (hasSubcategories) {
                        onToggle(category.id);
                    } else {
                        onCategoryClick(category);
                    }
                })}
                sx={{ display: "block" }}
            >
                <ListItemButton sx={{ pl: 3 + level }}>
                    <ListItemText
                        primary={category.nombre}
                        primaryTypographyProps={{
                            fontSize: 14,
                            fontFamily: STYLES.fontFamily,
                            fontWeight: 400,
                        }}
                    />
                    {hasSubcategories && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
            </MuiLink>

            {hasSubcategories && (
                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <MuiLink
                            href={href}
                            underline="none"
                            color="inherit"
                            onClick={interceptLeftClick(() => onViewAllClick(category))}
                            sx={{ display: "block" }}
                        >
                            <ListItemButton sx={{ pl: 3 + (level + 1) }}>
                                <ListItemText
                                    primary={`Ver todo en ${category.nombre}`}
                                    primaryTypographyProps={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                    }}
                                />
                            </ListItemButton>
                        </MuiLink>

                        {subcategories.map((subcategory) => renderCategory(subcategory, level + 1))}
                    </List>
                </Collapse>
            )}
        </>
    );
};
